import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { api } from './api';
import { RequestLoadDraftsCount, ReceiveLoadDraftsCount, FailLoadDraftsCount } from './action-types';

export const actionCreators = {
  loadDraftsCount: (): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch) => {
      dispatch(new RequestLoadDraftsCount());
      try {
        const count = await api.getDraftsCount();
        dispatch(new ReceiveLoadDraftsCount(count || 0));
      } catch {
        dispatch(new FailLoadDraftsCount());
      }
    }
};
